<template>
  <md-toast ref="toast" has-mask>
    <md-activity-indicator
      class="md-activity-indicator-css"
      type="spinner"
      :size="72"
      :text-size="14"
      color="light"
      text-color="white"
      vertical
    >
      {{ context }}
    </md-activity-indicator>
  </md-toast>
</template>

<script>
import { Toast, ActivityIndicator } from 'mand-mobile'
import i18n from '@/lang'

export default {
  name: 'PayLoading',
  components: {
    [Toast.component.name]: Toast.component,
    [ActivityIndicator.name]: ActivityIndicator
  },
  props: {
    context: {
      type: String,
      default: i18n.t('processing')
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isShow (value) {
      if (value) {
        this.$refs.toast.show()
      } else {
        this.$refs.toast.hide()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
